import React, { createContext, useContext, PropsWithChildren, useEffect } from 'react'
import { useNotifications } from '../../hooks/useNotifications'
import { Notification } from '../../modules/notifications/models/Notification'

interface NotificationsContextType {
  notifications: Notification[]
  unreadCount: number
  markAsRead: (notificationId: string) => Promise<void>
  loading: boolean
  loadNotifications: (userId: string) => Promise<void>
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined)

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext)
  if (!context) {
    throw new Error('useNotificationsContext must be used within NotificationsProvider')
  }
  return context
}

export const NotificationsProvider = ({
  children,
  token,
  userId,
}: PropsWithChildren<{ token: string; userId: string }>) => {
  const notificationsData = useNotifications(token, userId)
  useEffect(() => {
    if (userId) {
      notificationsData.loadNotifications(userId)
    }
  }, [userId])

  return (
    <NotificationsContext.Provider value={notificationsData}>
      {children}
    </NotificationsContext.Provider>
  )
}
